interface EventHeaderProps {
  event: {
    title: string;
    subtitle: string;
  };
}

export default function EventHeader({ event }: EventHeaderProps) {
  return (
    <div className="px-6 py-6">
      <h1 className="font-display text-3xl tracking-tight text-foreground">
        {event.title}
      </h1>
      <p className="mt-1.5 text-muted-foreground">{event.subtitle}</p>
    </div>
  );
}
